import type React from "react"
import { Card, CardContent, CardHeader } from "../card"

interface CareerCardProps {
  title: string
  description: string
  salary: string
  education: string
  funFact: string
  match: number
  icon: React.ReactNode
  onClick?: () => void
}

export const CareerCard: React.FC<CareerCardProps> = ({
  title,
  description,
  salary,
  education,
  funFact,
  match,
  icon,
  onClick,
}) => {
  return (
    <Card 
      className="border-slate-200 hover:shadow-lg transition-all duration-300 hover:border-teal-400 cursor-pointer"
      onClick={onClick}
    >
      <CardHeader>
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center">{icon}</div>
            <div>
              <h3 className="text-xl font-bold text-slate-900">{title}</h3>
              <p className="text-sm text-slate-600">{description}</p>
            </div>
          </div>
          <div className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-semibold whitespace-nowrap">
            {match}% Match
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div className="flex items-center justify-between bg-slate-50 rounded-lg p-3 border border-slate-200">
            <span className="font-semibold text-slate-700">Education</span>
            <span className="text-slate-700 text-sm text-right">{education}</span>
          </div>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
            <p className="text-amber-700 text-sm">{funFact}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}